import { inject, Injectable } from '@angular/core';
import { MpsUserService } from '@mps/services/mps-user.service';
import { DEFAULT_PROFILE, Profile, PROFILES, ProfileType, STORAGE_KEY } from '../models/profile.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private userService = inject(MpsUserService);
  private currentProfile = DEFAULT_PROFILE as ProfileType;

  getCurrentProfile(): ProfileType {
    return this.currentProfile;
  }

  getCurrentProfileData(): Profile {
    const currentId = this.getCurrentProfile();
    return PROFILES.find((p) => p.id === currentId) || PROFILES[0];
  }

  setCurrentProfile(profile: ProfileType): void {
    this.currentProfile = profile;
    this.saveToStorage(profile);
  }

  isHpcUser(): boolean {
    return this.getCurrentProfile() === 'hpg';
  }

  /**
   * Le potentiel n'est visible qu'en profil HPC, et uniquement pour les membres COMEX / RH
   */
  canViewPotentiel(): boolean {
    const user = this.userService.getUser();
    return this.isHpcUser() && !!(user?.b_comex || user?.b_rh);
  }

  /**
   * Charge depuis localStorage
   */
  public loadFromStorage(): ProfileType {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && ['hpg', 'cd', 'n17'].includes(stored)) {
        return stored as ProfileType;
      } else {
        return DEFAULT_PROFILE;
      }
    } catch (error) {
      console.warn('Erreur chargement profil:', error);
      return DEFAULT_PROFILE;
    }
  }

  /**
   * Sauvegarde dans localStorage
   */
  private saveToStorage(profile: ProfileType): void {
    try {
      localStorage.setItem(STORAGE_KEY, profile);
    } catch (error) {
      console.warn('Erreur sauvegarde profil:', error);
    }
  }
}
